import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Config } from "../core/config/config";
import { Dialog, DialogProps } from "../core/components/dialog";
import { FieldInstance } from "../core/components/field";
import { TextBox } from "../core/components/textBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect";
import React from "react"
export default class EditTranslations extends React.Component<EditTranslationsProps, any> {
    private _LOCAL_STORAGE_KEY = "EditTranslations_Translations_" + Config.user.languageId.toString();

    private _currentIsRowId: number = null;
    private _currentTabellenId: number = null;
    private _currentTarget: "value_0" | "value_1" | "value_text_0" = null;

    private _currentLanguageSelection: Array<{ Language: number, Sprache: string }> = [];
    private _translations = {};
    private _dialogRef: Dialog;
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: this.props.label,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (!Helper.hasValue(this.props.canSave) || this.props.canSave())
                    this._saveTranlations();
                },
                primary: true
            }
        ],
        afterClose: () => {
        },
        width: 500,
        height: 600,
        maxHeight: 600
    };

    constructor(props) {
        super(props);

        let ls = Helper.loadDataFromStorage(this._LOCAL_STORAGE_KEY);
        if (ls !== undefined)
            this._currentLanguageSelection = ls;
    }

    private _saveTranlations = () => {
        this._giveGermanValueBack();
        const noTranslations = Object.getOwnPropertyNames(this._translations).length == 0;
        if (!Helper.hasValue(this._currentIsRowId))
            return;
        HTTPService.post<JsonResultClass>(
            "TranslationsView/SaveTranslations",
            {
                tabellenId: this._currentTabellenId,
                isRowId: this._currentIsRowId,
                target: this._currentTarget,
                translations: noTranslations ? null : this._translations
            })
            .then(result => {
                if (result.Code > 0) {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });    
    }

    private _giveGermanValueBack = () => {
        this.props.saveGerman(this._translations["lang0"], this._currentTarget);
    }

    public openDialog = (isRowId: number, tabellenId: number, target: "value_0" | "value_1" | "value_text_0", germanValue: string) => {
        this._currentIsRowId = isRowId;
        this._currentTabellenId = tabellenId;
        this._currentTarget = target;

        HTTPService.get("TranslationsView/GetTranslations?tabellenId=" + this._currentTabellenId + "&isRowId=" + isRowId + "&target=" + this._currentTarget + "&germanValue=" + encodeURIComponent(germanValue))
            .then(result => {
                this._translations = result;
                this._dialogRef.open();
                this.setState({});
            });
    }

    private _handleTextBoxesChanges = (field: { model: string, name: string }, value: any) => {
        this._translations["lang" + field.name] = value;
    }

    private _renderTextBoxes = () => {
        let tbs = [];
        for (let selection of this._currentLanguageSelection) {
            let tb = this._factory.getDefaultTextBoxProps();            
            tb.field.name = selection.Language.toString();
            tb.field.multiLine = this._currentTarget == "value_text_0";
            tb.onChange = this._handleTextBoxesChanges;
            tb.value = this._translations !== null && Helper.hasValue(this._translations["lang" + selection.Language]) ? this._translations["lang" + selection.Language] : "";
            tbs.push(
                <FieldInstance key={selection.Language} label={selection.Sprache} noHover={true} >
                    <TextBox {...tb} />
                </FieldInstance>
            );
        }
        return tbs;
    }

    render() {
        let multiSelectLanguage: MultiSelectProps = this._factory.getDefaultMultiSelectProps();
        multiSelectLanguage.value = this._currentLanguageSelection;
        multiSelectLanguage.field.dataSourceUrl = "TranslationsView/GetLanguages"
        multiSelectLanguage.field.dataValueField = "Language";
        multiSelectLanguage.field.dataTextField = "Sprache";
        multiSelectLanguage.field.listWidth = null;
        multiSelectLanguage.onChange = (field: { model: string }, value) => {
            this._currentLanguageSelection = value;
            Helper.saveDataToStorage(this._LOCAL_STORAGE_KEY, value, false);
            this.setState({});
        };

        return (
            <Dialog {...this._dialogProps} ref={(r) => this._dialogRef = r}>
                {
                    <div>
                        <FieldInstance label={Config.translations.language} noHover={true} >
                            <MultiSelect {...multiSelectLanguage} />
                        </FieldInstance>
                        {this._renderTextBoxes()}
                    </div>
                }
            </Dialog>
        );
    }
};

interface EditTranslationsProps {
    label: string;
    saveGerman?: (value: string, target: "value_0" | "value_1" | "value_text_0") => void;
    canSave?: () => void
}